import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { MyReportsFolder, ReportsInFolder } from '../../reporting-framework.model';
import { ReportingFrameworkService } from '../../reporting-framework.service';

@Component({
  selector: 'app-folders-this-report-dialog',
  templateUrl: './folders-this-report-dialog.component.html',
  styleUrls: ['./folders-this-report-dialog.component.css']
})
export class FoldersThisReportDialogComponent implements OnInit {

  allCheckBox = false;
  report: ReportsInFolder;
  reportFolders: MyReportsFolder[];
  folderTableColumns = ['Checkbox', 'FolderName', 'FolderDescription'];
  foldersTableData = new TylerMatTableDataSource();
  checkIndeterminate = false;

  constructor(
    private dialogRef: MatDialogRef<FoldersThisReportDialogComponent>,
    private reportingFrameworkService: ReportingFrameworkService
  ) { }

  ngOnInit() {
    this.reportFolders.forEach(folder => {
      if (folder.ReportsInFolder.find(x => x.ReportId == this.report.ReportId) != null) {
        folder.IsSelected = true;
      }
    });

    this.foldersTableData.data = this.reportFolders;
    this.parentCheckBoxChange();
  }

  allCheckBoxChange() {
    this.reportFolders.forEach(fdr => {
      fdr.IsSelected = this.allCheckBox;
    });

    const selectedCount = this.foldersTableData.data.filter(x => x.IsSelected == true).length;
    if (selectedCount > 0) {
      if (this.foldersTableData.data.length === selectedCount) {
        this.allCheckBox = true;
      }
      else {
        this.checkIndeterminate = true;
      }
    } else {
      this.checkIndeterminate = false;
    }
  }

  parentCheckBoxChange() {
    const selectedCount = this.foldersTableData.data.filter(x => x.IsSelected == true).length;
    if (selectedCount > 0) {
      if (this.foldersTableData.data.length === selectedCount) {
        this.allCheckBox = true;
      }
      else {
        this.checkIndeterminate = true;
      }
    } else {
      this.checkIndeterminate = false;
    }
  }

  saveClick() {
    const folderIds: Number[] = [];
    this.reportFolders.filter(x => x.IsSelected == true).forEach(folder => {
      folderIds.push(folder.Id);
    });

    this.reportingFrameworkService.addReportInFolders(this.report.ReportId, folderIds).subscribe(result => {
      if (result == true) {
        this.dialogRef.close('save');
      }
    });
  }

  cancelClick() {
    this.dialogRef.close('cancel');
  }

}
